import React, { useEffect, useRef } from 'react';
import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';
import { useIntl } from 'react-intl';
import { Select } from 'antd';
import messages from 'translations/messages';

const QUERY = gql`
  query CustomersSelect {
    customers {
      id
      name
      dataSources {
        id
        title
      }
    }
  }
`;

const CustomerSelect = ({ allowClear, autoFocus, value, ...rest }) => {
  const { formatMessage: $t } = useIntl();
  const selectRef = useRef(null);

  const { loading, data } = useQuery(QUERY);

  const customerOptions = data?.customers.map(customer => ({ value: customer.id, label: customer.name, search: `${customer.name} ${customer.dataSources?.map(w => w.title).join(' ')} ` }));

  useEffect(() => {
    if (autoFocus) {
      selectRef.current.focus();
    }
  }, [autoFocus]);

  const placeholder = $t(messages[allowClear ? 'allCustomers' : 'selectCustomer']);

  return (
    <Select
      ref={selectRef}
      style={{ width: '100%' }}
      loading={loading || rest.loading}
      showSearch
      optionFilterProp="search"
      allowClear={allowClear}
      placeholder={placeholder}
      options={customerOptions}
      value={loading ? $t(messages.loading) : value}
      {...rest}
    />
  );
};

export default CustomerSelect;
